<template>
  <div class="credit">
    <!--内容区域-->
    <!--新增/删除按钮-->
    <!-- <vxe-toolbar>
      <template v-slot:buttons>
        <div style="padding-bottom: 10px"> -->
    <!-- <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-save"
            @click="add()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-add"
            />
            {{ $t('credit.btnList.add') }}
          </vxe-button>
          <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-delete"
            @click="removeSelected()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-white-delete"
            />
            {{ $t('credit.btnList.del') }}
          </vxe-button>
          <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-save"
            @click="edit()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-white-edit"
            />
            编辑
          </vxe-button> -->
    <!-- <vxe-button size="medium" type="primary" class="vxe-btn-save" @click="exportData">
            导出</vxe-button
          > -->
    <!-- </div>
      </template>
    </vxe-toolbar> -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :customVisible="false"
        :reserve="true"
        :paging="false"
        :setting="false"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'theDate'">
              {{ formatColumn(scope.row[item.prop]) }}
            </span>
            <span v-else>{{ scope.row[item.prop] || '-' }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog title="单据明细新增" :visible.sync="addDialogVisible" width="55%">
      <div>
        <el-form :model="formData" :rules="rules" label-width="100px" ref="formData">
          <div class="form-content">
            <el-form-item label="项目编号" prop="formData">
              <el-input v-model="formData.projectCode" disabled></el-input>
            </el-form-item>
            <el-form-item label="单据类型" prop="billType">
              <el-select v-model="formData.billType" placeholder="请选择单据类型">
                <el-option
                  v-for="item in billTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经办部门" prop="dealDepartmentCode">
              <tree-select
                style="width: 100%"
                ref="treeSelect"
                :model="formData.dealDepartmentCode"
                :apiUrl="treeData.apiUrl"
                :apiData="treeData.apiData"
                :clearable="treeData.clearable || true"
                :isName="treeData.isName"
                :multiple="treeData.multiple"
                :returnType="treeData.returnType || ''"
                :currentValue="formData.dealDepartmentCode || null"
                @setSearchModal="setSearchModal"
                :normalizerFlag="treeData.normalizerFlag"
              ></tree-select>
            </el-form-item>
            <el-form-item label="单据编号" prop="businessNo">
              <el-input v-model="formData.businessNo"></el-input>
            </el-form-item>
            <!--<el-form-item label="合作伙伴" prop="partnerName">-->
            <!--  <el-input v-model="formData.partnerName"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="币种" prop="currency">-->
            <!--  <el-input v-model="formData.currency"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="金额" prop="amount">
              <el-input v-model="formData.amount"></el-input>
            </el-form-item>
            <el-form-item label="公司编码">
              <el-input v-model="formData.projectCompanyCode" disabled></el-input>
            </el-form-item>
            <el-form-item label="公司名称">
              <el-input v-model="formData.projectCompanyName" disabled></el-input>
            </el-form-item>
            <el-form-item label="日期" prop="theDate">
              <el-date-picker
                v-model="formData.theDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  import SiruiTable from '@/components/SiruiTable';
  // import SearchModal from '@/components/SearchModal';
  import moment from 'moment';
  import DataBaseAPI from '@/api/dataBase';
  import treeSelect from '@/components/form-item/tree-select';
  import COM_API from '@/api/masterData/company.js';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      // SearchModal,
      treeSelect,
    },
    name: 'creditStatisticsDetailColumns',
    data() {
      return {
        footerTotalCols: {
          amount: [
            'collectionAmount',
            'payAmount',
            'supplierRefundAmount',
            'customersRefundAmount',
            'redInvoiceAmount',
            'blueInvoiceAmount',
          ],
        },
        billTypeList: [],
        formData: {
          projectCode: null,
          projectName: null,
          billType: null,
          businessNo: null,
          partnerName: null,
          currency: null,
          amount: null,
          projectCompanyCode: null,
          projectCompanyName: null,
          theDate: null,
          dealDepartmentName: null,
          dealDepartmentCode: null,
        },
        load: false,
        img: '/static/img/tips.png',
        query: {
          businessDepartment: '', //事业部门
          partnerType: '', //合作伙伴类型
          onlyShow: '', //只显示母公司额度
          partner: '', //业务合作伙伴
          creditCode: '', //信用账户号
        },
        customerNo: '',
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        rowData: {}, //被选中的列,
        addDialogVisible: false,
      };
    },
    computed: {
      treeData() {
        return {
          name: this.$t('salePurchase.search.contractBusinessDepartment'),
          type: 'treeSelect',
          apiUrl: COM_API.LIST_COMPANY_API,
          apiData: {
            tenantCode: this.userInfo.userInfo.tenantCode,
            adminFlag: this.userInfo.userInfo.adminFlag,
            departmentBusinessLimitFlag: true,
          },
          multiple: false,
          clearable: false,
        };
      },
      //表格显示字段
      columnListDefault: {
        get() {
          if (this.$route.query?.type === 'projectQuota') {
            return [
              { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
              { prop: 'projectCode', label: '项目编号' },
              { prop: 'billTypeName', label: '单据类型' },
              { prop: 'businessNo', label: '单据编号' },
              // { prop: "partnerName", label: "合作伙伴",},
              // { prop: 'currencyName', label: '币种' },
              { prop: 'collectionAmount', label: '收款' },
              { prop: 'supplierRefundAmount', label: '供应商退款' },
              { prop: 'payAmount', label: '付款' },
              { prop: 'customersRefundAmount', label: '退客户款' },
              { prop: 'projectCompanyCode', label: '公司编码' },
              { prop: 'projectCompanyName', label: '公司名称' },
              { prop: 'theDate', label: '日期' },
              { prop: 'dealDepartmentName', label: '经办部门' },
              { prop: 'partnerName', label: '合作伙伴' },
            ];
          } else {
            return [
              { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
              { prop: 'projectCode', label: '项目编号' },
              { prop: 'billTypeName', label: '单据类型' },
              { prop: 'businessNo', label: '单据编号' },
              // { prop: "partnerName", label: "合作伙伴",},
              // { prop: 'currencyName', label: '币种' },
              { prop: 'collectionAmount', label: '收款' },
              { prop: 'redInvoiceAmount', label: '开票（红票）' },
              { prop: 'blueInvoiceAmount', label: '开票（蓝票）' },
              { prop: 'customersRefundAmount', label: '退客户款' },
              { prop: 'projectCompanyCode', label: '公司编码' },
              { prop: 'projectCompanyName', label: '公司名称' },
              { prop: 'theDate', label: '日期' },
              { prop: 'dealDepartmentName', label: '经办部门' },
              { prop: 'partnerName', label: '合作伙伴' },
            ];
          }
        },
      },
      itemRequest() {
        return {
          API: '/sales/project/listPage',
          query: {
            projectName: null,
          },
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: [
            { prop: 'projectName', label: '项目名称', width: 180 },
            { prop: 'projectCode', label: '项目编码', width: 120 },
            { prop: 'companyNames', label: '公司名称' },
            { prop: 'companyCodes', label: '公司代码', width: 120 },
            { prop: 'creditLine', label: '项目授信额度（元）', width: 120 },
          ],
        };
      },
      rules() {
        return {
          projectName: [{ required: true, message: '请选择项目', trigger: 'change' }],
          billType: [{ required: true, message: '请选择单据类型', trigger: 'change' }],
          businessNo: [{ required: true, message: '请输入单据编号', trigger: 'blur' }],
          partnerName: [{ required: true, message: '请输入合作伙伴', trigger: 'blur' }],
          // currencyName: [{ required: true, message: '请输入币种', trigger: 'blur' }],
          amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
          theDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
          dealDepartmentCode: [{ required: true, message: '请选择经办部门', trigger: 'change' }],
        };
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.setProjectName();
      this.getDict();
      this.getButtonList();
    },
    methods: {
      getButtonList() {
        this.menuButtonList = [
          {
            id: '2021042915423814459',
            label: '导出',
            index: null,
            attributes: {
              buttonCode: '2021042915423814459',
              buttonName: '导出',
              buttonUrl: 'exportData',
              buttonStyle: '',
            },
            pid: '0',
            type: '0',
          },
        ];
      },
      setSearchModal(model, row) {
        this.formData.dealDepartmentCode = row;
        this.$nextTick(() => {
          this.$refs.formData.validateField('dealDepartmentCode');
        });
      },
      getDict() {
        let _this = this;
        function list(key) {
          let tenantCode = _this.userInfo.userInfo.tenantCode;
          _this.$axios
            .post(DataBaseAPI.DIC_CREDIT_API, { dictType: key, tenantCode })
            .then((res) => {
              if (0 == res.data.code) {
                _this.billTypeList = res.data.data;
              }
            });
        }
        if (_this.$route.query.type === 'projectQuota') {
          list('PROJECT_DETAIL');
        } else {
          list('PROJECT_AMOUNT_DETAIL');
        }
      },
      confirm() {
        this.$refs.formData.validate((valid) => {
          let params = {
            quotaType: this.$route.query.type,
            ...this.formData,
          };
          if (valid) {
            this.$axios
              .post('/sales/creditLimitSummary/saveCreditLimitDetail', params)
              .then((res) => {
                if (res.data.code == '0') {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getData();
                  this.multipleSelection = [];
                } else {
                  this.$message({
                    type: 'success',
                    message: '操作失败',
                  });
                }
                this.addDialogVisible = false;
              });
          } else {
            return false;
          }
        });
      },
      //删除选中行
      removeSelected() {
        let data = this.multipleSelection;
        let idList = [];
        let breakFun = false;
        for (let i = 0; i < data.length; i++) {
          if (data[i]?.manually) {
            if (data[i]?.id) idList.push(data[i].id);
          } else {
            breakFun = !data[i]?.manually;
            break;
          }
        }
        if (breakFun) {
          this.$message({
            type: 'info',
            message: '系统生成数据不能删除！',
          });
          return;
        }
        if (data && data.length > 0) {
          this.load = true;
          this.$confirmAction()
            .then(() => {
              this.$axios
                .post('/sales/creditLimitSummary/deleteCreditLimitDetail', {
                  idList: idList,
                  projectCode: this.$route.query.projectCode,
                })
                .then(() => {
                  this.getData();
                });
              this.load = false;
            })
            .catch(() => {
              this.load = false;
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('applicationCredit.msg.delSelectedModify'),
            type: 'error',
          });
        }
      },
      setProjectName() {
        this.$axios
          .post('/sales/project/listPage', { projectCode: this.$route.query.projectCode })
          .then((res) => {
            let value = res.data.data.records;
            if (value[0]) {
              this.formData.projectName = value[0]?.projectName;
              this.formData.projectCode = value[0]?.projectCode || null;
              this.formData.projectCompanyCode = value[0].companyCodes || null;
              this.formData.projectCompanyName = value[0].companyNames;
            }
          });
      },
      //获取数据
      getData() {
        this.load = true;
        let params = {
          projectCode: this.$route.query.projectCode,
          quotaType: this.$route.query.type,
          pageSize: this.$refs.siruiTable.page.pageSize,
          pageNum: this.$refs.siruiTable.page.pageNum,
        };
        this.$axios
          .post('/sales/creditLimitSummary/listCreditDetailProject', params)
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              this.tableData = res.data.data;
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        this[type]();
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'edit') {
          if (JSON.stringify(this.multipleSelection) == '{}') {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.noSelectEdit'),
              type: 'error',
            });
          } else {
            let path = {
              title: '',
              path: 'creditAdd',
              name: '',
              query: { id: 1 },
            };
            this.$store.commit('LIST_ADD_TABS', path);
          }
        }
      },
      //新增
      add() {
        this.addDialogVisible = true;
      },
      edit() {
        if (this.multipleSelection.length == 0 || this.multipleSelection.length > 1) {
          this.$message({
            type: 'info',
            message: '请选择一条数据',
          });
          return;
        }
        if (!this.multipleSelection[0]?.manually) {
          this.$message({
            type: 'info',
            message: '该数据系统生成不能修改！',
          });
          return;
        }

        this.formData = {
          ...this.formData,
          ...this.multipleSelection[0],
          theDate: this.formatColumn(this.multipleSelection[0].theDate),
        };
        console.log(this.formData);
        this.addDialogVisible = true;
      },
      //删除
      del() {
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            //TODO调用接口
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            //如果有错误返回，提示信息
            this.$alert(this.$t('applicationCredit.msg.errText'));
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          title: '',
          path: 'creditDetail',
          name: '',
          query: { creditRequestNo: value.row.creditRequestNo },
        };
        this.$store.commit('LIST_ADD_TABS', path);
      },
      //导出
      exportData() {
        this.load = true;
        this.$axios
          .post('/sales/creditLimitSummary/exportCreditDetailProject', {
            quotaType: this.$route.query.type,
            projectCode: this.$route.query.projectCode,
          })
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              window.location.href = res.data.data;
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
      },
      formatColumn(row) {
        if (!row) {
          return '-';
        }
        return moment(row).format('YYYY-MM-DD');
      },
      /**页面必要代码End */
    },
  };
</script>
<style lang="scss" scoped>
  .form-content {
    display: flex;
    flex-wrap: wrap;
    ::v-deep .el-form-item {
      width: 300px;
    }
    ::v-deep .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-dialog__body {
    min-height: 240px;
  }
</style>
